module.exports = __webpack_public_path__ + "static/img/r_025.2684ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_025.jpg
// module id = KD/w
// module chunks = 1